module.exports = __webpack_public_path__ + "media/images/pic/hero/mountain-ef942ea21395b12915fc336b0d364a5d.webp";